<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding" style="min-width: 0">
      <span class="title">{{ 'Wartung' | mrTranslate }}</span>
    </div>
    <div class="header-actions clr-justify-content-between" style="flex-shrink: 1">
      <div class="d-f row clr-flex-grow-1 clr-align-self-center h-auto" style="column-gap: 15px">
        @if (!isReadOnly()) {
          <div class="width100 h-auto flex-1-1-0" style="min-width: 100px">
            <clr-date-container class="mt-0">
              <label class="headerFont" for="date">
                {{ 'Datum' | mrTranslate }}
              </label>
              <input
                type="date"
                clrDate
                class="headerFont"
                [ngModel]="wartungsdate() | localeDate"
                (ngModelChange)="wartungsdate.set(localeDate.tosql($event))"
                [ngModelOptions]="{ updateOn: 'blur', standalone: true }" />
            </clr-date-container>
          </div>
          <div class="flex-2-2-0 width100 h-auto" style="min-width: 100px; max-width: 600px">
            <clr-control-container class="mt-0">
              <label class="clr-col-12 clr-col-md-12 headerFont">
                {{ 'Bemerkung' | mrTranslate }}
              </label>
              <app-datalist-input
                [datalist]="bemerkungen$ | async"
                class="clr-col-12 clr-col-md-12 w-100-p"
                style="--ng-input-text-color: var(--clr-header-font-color)"
                [(ngModel)]="bemerkung"
                [ngModelOptions]="{ standalone: true }" />
            </clr-control-container>
          </div>
        } @else {
          <div class="width100 h-auto flex-1-1-0" style="min-width: 100px">
            <clr-input-container class="mt-0">
              <label class="headerFont">
                {{ 'Datum' | mrTranslate }}
              </label>
              <input
                clrInput
                type="text"
                readonly
                class="headerFont ellipsis"
                [ngModel]="wartungsdate() | localeDate"
                [ngModelOptions]="{ standalone: true }" />
            </clr-input-container>
          </div>
          @if (bemerkung()) {
            <div class="flex-2-2-0 width100 h-auto" style="min-width: 100px; max-width: 600px">
              <clr-input-container class="mt-0">
                <label class="headerFont">
                  {{ 'Bemerkung' | mrTranslate }}
                </label>
                <input
                  clrInput
                  type="text"
                  readonly
                  class="headerFont ellipsis"
                  [ngModel]="bemerkung()"
                  [ngModelOptions]="{ standalone: true }" />
              </clr-input-container>
            </div>
          }
        }
        <div class="width100 h-auto flex-1-1-0" style="min-width: 75px">
          <clr-input-container class="mt-0">
            <label class="headerFont">
              {{ 'Zuständig' | mrTranslate }}
            </label>
            <input
              clrInput
              type="text"
              readonly
              class="headerFont ellipsis"
              [ngModel]="objekt()?.verantwortlich"
              [ngModelOptions]="{ standalone: true }" />
          </clr-input-container>
        </div>
        <div class="width100 h-auto flex-1-1-0" style="min-width: 75px">
          <clr-input-container class="mt-0">
            <label class="headerFont">
              {{ 'Maske' | mrTranslate }}
            </label>
            <input
              clrInput
              type="text"
              readonly
              class="headerFont ellipsis"
              [ngModel]="objekt()?.maske"
              [ngModelOptions]="{ standalone: true }" />
          </clr-input-container>
        </div>
      </div>
      <div class="header-nav">
        @if (isReadOnly()) {
          @if (objekt()?.RevBild) {
            <a class="nav-link nav-icon" href="javascript:void(0);" (click)="setWartungMedia(objekt())">
              <cds-icon shape="image-gallery" [title]="'Media anzeigen' | mrTranslate" />
            </a>
          }
          @if (assignedZaehlerName(); as name) {
            <a class="nav-link nav-icon" href="javascript:void(0);" (click)="exportZaehlerExcel()">
              <cds-icon shape="excel" [title]="'Zähler nach Excel exportieren' | mrTranslate" />
            </a>
          }
        } @else {
          <a
            class="nav-link nav-icon"
            href="javascript:void(0);"
            (click)="mediaRow.set(objekt()); isPreviewModalOpen.set(true)">
            <cds-icon shape="camera" [title]="'Media verwalten' | mrTranslate" />
          </a>
        }
        <a
          class="nav-link nav-icon"
          href="javascript:void(0);"
          (click)="detailPanel.open(); isDetailPanelOpened.set(true)">
          <cds-icon shape="tree-view" [title]="'Historie öffnen' | mrTranslate" />
        </a>
        <a class="nav-link nav-icon" href="javascript:void(0);" (click)="close()">
          <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
        </a>
      </div>
    </div>
  </header>
  <clr-tabs class="h-60 margin-10-lr padding-12-b">
    <clr-tab class="wartung">
      <button clrTabLink>
        {{ 'Maske' | mrTranslate }} - {{ objekt()?.maske ?? ('gelöscht' | mrTranslate) }}
        @if (wartungForm()?.touched && wartungForm()?.invalid) {
          <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
        }
      </button>
      <clr-tab-content>
        @let async =
          {
            groupedWartung: wartung$ | async,
            mehListe: meh$ | async,
          };
        @if (async.groupedWartung | keyvalue: null; as wartungMap) {
          <div class="h-100 scroll padding-6-t">
            @if (wartungMap?.length) {
              @if (!isReadOnly()) {
                @let mehListe = async.mehListe;
                <form clrForm #wartungForm ngForm (ngSubmit)="saveIfValid()" clrLabelSize="12" class="width100 w-100-p">
                  <clr-accordion id="wartungAccordion" clrAccordionMultiPanel="true">
                    @for (headerBlock of wartungMap; track headerBlock.key) {
                      @let header = headerBlock.value;
                      @let helper = header.helper;
                      <clr-accordion-panel
                        [clrAccordionPanelOpen]="$first"
                        #headerGroup="ngModelGroup"
                        [ngModelGroup]="header.key">
                        <clr-accordion-title class="basealign">
                          {{ header.name }}
                          @if (helper?.FileTyp || helper?.HelpBeschreibung) {
                            <button
                              type="button"
                              class="btn btn-sm btn-icon btn-link"
                              [title]="'Beschreibung' | mrTranslate"
                              (click)="
                                $event.stopPropagation();
                                openedHelperId.set(headerBlock.key);
                                isHelperModalOpen.set(true)
                              ">
                              <cds-icon shape="help" />
                            </button>
                          }
                        </clr-accordion-title>
                        <clr-accordion-content [clrIfExpanded]="$first" class="wartungArtItem">
                          <table class="table margin-0-t table-compact nowrap" style="table-layout: fixed">
                            <thead style="position: sticky; top: -7px; z-index: 3">
                              <tr>
                                <th class="ellipsis" style="width: 70px"></th>
                                <th class="left ellipsis" style="width: 30%">{{ 'Wartungsart' | mrTranslate }}</th>
                                <th style="width: 70px">
                                  <span>{{ 'i.O.' | mrTranslate }}</span>
                                  <button
                                    class="btn btn-sm btn-icon btn-link clr-col-auto"
                                    style="margin: -5px 0"
                                    tabindex="-1"
                                    type="button"
                                    [title]="'Alle aus-/abwählen' | mrTranslate"
                                    (click)="
                                      iOAlle.checked = !iOAlle.checked; checkAll(iOAlle.checked, headerGroup.control)
                                    ">
                                    <input
                                      type="checkbox"
                                      #iOAlle
                                      hidden
                                      [checked]="header.children | get: isAllSelected" />
                                    <cds-icon [shape]="iOAlle.checked ? 'circle' : 'success-standard'" />
                                  </button>
                                </th>
                                <th class="ellipsis">{{ 'Messwert' | mrTranslate }}</th>
                                <th class="left ellipsis">{{ 'Maßnahmen' | mrTranslate }}</th>
                                <th style="width: 70px">{{ 'FK' | mrTranslate }}</th>
                                <th class="ellipsis">{{ 'Umfang' | mrTranslate }}</th>
                                <th class="left">
                                  <div class="d-f row">
                                    <div class="clr-col flex-1-1-0 ellipsis">
                                      {{ 'Mengeneinheiten' | mrTranslate }}
                                    </div>
                                    <button
                                      class="btn btn-sm btn-icon btn-link clr-col-auto"
                                      style="margin: -5px 0"
                                      tabindex="-1"
                                      type="button"
                                      [title]="'Tabelle verwalten' | mrTranslate"
                                      (click)="isBaseModalOpen.set(true)">
                                      <cds-icon shape="pencil" />
                                    </button>
                                  </div>
                                </th>
                                @if (showHilfeColumn()) {
                                  <th class="ellipsis" style="width: 70px">{{ 'Hilfe' | mrTranslate }}</th>
                                }
                              </tr>
                            </thead>
                            <tbody>
                              @for (artBlock of header.children | keyvalue: null; track artBlock.key) {
                                @let row = artBlock.value;
                                <tr #artGroup="ngModelGroup" [ngModelGroup]="row.key">
                                  <input type="number" name="ID" [ngModel]="row.ID" hidden />
                                  <input type="text" name="wartungsart" [ngModel]="row.artName" hidden />
                                  <input type="number" name="omazsid" [ngModel]="row.OMAZSID" hidden />
                                  @if (row.artTyp != 0) {
                                    <td>
                                      <a
                                        href="javascript:void(0);"
                                        (click)="mediaRow.set(row); isPreviewModalOpen.set(true)">
                                        <cds-icon shape="camera" size="20" />
                                      </a>
                                    </td>
                                    <td class="left ellipsis text-wrap">{{ row.artName }}</td>
                                    <td class="centred">
                                      <clr-checkbox-container class="center">
                                        <label hidden></label>
                                        <clr-checkbox-wrapper>
                                          <input
                                            type="checkbox"
                                            clrCheckbox
                                            #iO="ngModel"
                                            [(ngModel)]="row.iO"
                                            name="iO"
                                            (ngModelChange)="setValidations(iO.value, artGroup.control)" />
                                        </clr-checkbox-wrapper>
                                      </clr-checkbox-container>
                                    </td>
                                    <td class="width100">
                                      @if (row.artTyp == 2) {
                                        <clr-number-input-container>
                                          <input
                                            clrNumberInput
                                            name="messwert"
                                            [(ngModel)]="row.Messwert"
                                            type="number"
                                            step="0.1"
                                            required />
                                          <clr-control-error *clrIfError="'required'">
                                            {{ 'Erforderlich' | mrTranslate }}
                                          </clr-control-error>
                                        </clr-number-input-container>
                                      } @else {
                                        -
                                      }
                                    </td>
                                    <td class="left width100">
                                      <clr-control-container>
                                        <app-datalist-input
                                          name="massnahmen"
                                          [datalist]="row.zuordnungen?.arbeiten | keyvalue"
                                          [labelPath]="'key'"
                                          [valuePath]="'key'"
                                          [(ngModel)]="row.arbeitName"
                                          (ngModelChange)="createArbeitAndFindFK(row)"
                                          [ngModelOptions]="{ updateOn: 'blur' }" />
                                        <clr-control-error *clrIfError="'required'">
                                          {{ 'Erforderlich' | mrTranslate }}
                                        </clr-control-error>
                                      </clr-control-container>
                                      <input type="number" name="arbeitID" [ngModel]="row.arbeitID" hidden />
                                    </td>
                                    <td class="width100">
                                      <clr-select-container>
                                        <select clrSelect name="fk" [(ngModel)]="row.FK">
                                          <option [disabled]="!row.iO && requiredFK()" [ngValue]="null"></option>
                                          @for (fk of rangeFK; track $index) {
                                            <option [ngValue]="+fk">{{ fk }}</option>
                                          }
                                        </select>
                                        <clr-control-error *clrIfError="'required'">
                                          {{ 'Erforderlich' | mrTranslate }}
                                        </clr-control-error>
                                      </clr-select-container>
                                    </td>
                                    <td class="width100">
                                      <clr-number-input-container>
                                        <input
                                          clrNumberInput
                                          name="umfang"
                                          type="number"
                                          step="1"
                                          min="0"
                                          [(ngModel)]="row.RevUmfang"
                                          [ngModelOptions]="{ updateOn: 'blur' }" />
                                      </clr-number-input-container>
                                    </td>
                                    <td class="width100">
                                      <clr-select-container>
                                        <select clrSelect name="meh" [(ngModel)]="row.RevME">
                                          @for (meh of mehListe; track $index) {
                                            <option [value]="meh">{{ meh }}</option>
                                          }
                                        </select>
                                      </clr-select-container>
                                    </td>
                                    @if (showHilfeColumn()) {
                                      <td>
                                        @if (row.FileTyp || row.HelpBeschreibung) {
                                          <button
                                            type="button"
                                            (click)="openedHelperId.set(artBlock.key); isHelperModalOpen.set(true)"
                                            class="btn btn-sm btn-icon btn-link centred"
                                            [title]="'Beschreibung' | mrTranslate">
                                            <cds-icon shape="help" />
                                          </button>
                                        }
                                      </td>
                                    }
                                  }
                                </tr>
                              }
                            </tbody>
                          </table>
                        </clr-accordion-content>
                      </clr-accordion-panel>
                    }
                  </clr-accordion>
                  <button type="submit" class="btn btn-primary margin-24-l">
                    {{ 'Speichern' | mrTranslate }}
                  </button>
                </form>
              } @else {
                <clr-accordion id="wartungAccordion" clrAccordionMultiPanel="true" class="nm">
                  @for (headerBlock of wartungMap; track headerBlock.key) {
                    @let header = headerBlock.value;
                    @let helper = header.helper;
                    <clr-accordion-panel [clrAccordionPanelOpen]="$first">
                      <clr-accordion-title class="basealign">
                        {{ header.name }}
                        @if (helper?.FileTyp || helper?.HelpBeschreibung) {
                          <button
                            type="button"
                            class="btn btn-sm btn-icon btn-link"
                            [title]="'Beschreibung' | mrTranslate"
                            (click)="
                              $event.stopPropagation(); openedHelperId.set(headerBlock.key); isHelperModalOpen.set(true)
                            ">
                            <cds-icon shape="help" />
                          </button>
                        }
                      </clr-accordion-title>
                      <clr-accordion-content [clrIfExpanded]="$first" class="wartungArtItem w-100-p">
                        <table class="table margin-0-t table-compact nowrap w-100-p" style="table-layout: fixed">
                          <thead style="position: sticky; top: -7px; z-index: 3">
                            <tr>
                              <th style="width: 70px"></th>
                              <th class="left ellipsis" style="width: 30%">{{ 'Wartungsart' | mrTranslate }}</th>
                              <th style="width: 70px">{{ 'i.O.' | mrTranslate }}</th>
                              <th class="ellipsis">{{ 'Messwert' | mrTranslate }}</th>
                              <th class="left ellipsis">{{ 'Maßnahmen' | mrTranslate }}</th>
                              <th style="width: 70px">{{ 'FK' | mrTranslate }}</th>
                              <th class="ellipsis">{{ 'Umfang' | mrTranslate }}</th>
                              <th class="ellipsis">{{ 'Mengeneinheiten' | mrTranslate }}</th>
                              @if (showHilfeColumn()) {
                                <th class="ellipsis" style="width: 70px">{{ 'Hilfe' | mrTranslate }}</th>
                              }
                            </tr>
                          </thead>
                          <tbody>
                            @for (artBlock of header.children | keyvalue: null; track artBlock.key) {
                              @let row = artBlock.value;
                              <tr>
                                <td>
                                  <a
                                    href="javascript:void(0);"
                                    (click)="setWartungMedia(row)"
                                    [class.deactivate]="!row.RevBild">
                                    <cds-icon [shape]="!row.RevBild ? 'blank' : 'image-gallery'" size="20" />
                                  </a>
                                </td>
                                <td class="left ellipsis text-wrap">{{ row.artName }}</td>
                                <td>
                                  @if (row.iO) {
                                    <cds-icon shape="success-standard" solid="true" style="fill: #2ec0ff" />
                                  } @else {
                                    <cds-icon shape="circle" />
                                  }
                                </td>
                                <td>{{ row.Messwert || '-' }}</td>
                                <td class="left ellipsis">{{ row.arbeitName }}</td>
                                <td>{{ row.FK }}</td>
                                <td>{{ row.RevUmfang }}</td>
                                <td>{{ row.RevME }}</td>
                                @if (showHilfeColumn()) {
                                  <td>
                                    @if (row.FileTyp || row.HelpBeschreibung) {
                                      <button
                                        type="button"
                                        (click)="openedHelperId.set(artBlock.key); isHelperModalOpen.set(true)"
                                        class="btn btn-sm btn-icon btn-link centred"
                                        [title]="'Beschreibung' | mrTranslate">
                                        <cds-icon shape="help" />
                                      </button>
                                    }
                                  </td>
                                }
                              </tr>
                            }
                          </tbody>
                        </table>
                      </clr-accordion-content>
                    </clr-accordion-panel>
                  }
                </clr-accordion>
              }
            } @else {
              <div>{{ 'Keine Dateien vorhanden' | mrTranslate }}</div>
            }
          </div>
        }
      </clr-tab-content>
    </clr-tab>
    @if (assignedZaehlerName(); as name) {
      <clr-tab class="zaehler">
        <button clrTabLink>
          {{ 'Zähler' | mrTranslate }} - {{ name }}
          @if (zaehlerStore.toBeSaved()) {
            <cds-icon solid shape="exclamation-triangle" class="invalid-red" />
          }
        </button>
        <clr-tab-content>
          <div class="h-100 scroll">
            <app-zaehlertab (saveWartung)="wartungForm().ngSubmit.emit()" />
          </div>
        </clr-tab-content>
      </clr-tab>
    }
  </clr-tabs>
</div>
<clr-side-panel id="detailViewSidePanel" #detailPanel>
  <div class="side-panel-body">
    @if (isDetailPanelOpened() && objekt()?.OSTAMMID) {
      <app-detailview [ostammid]="objekt().OSTAMMID" (enlarge)="handleDetailviewEnlarge($event, detailPanel)" />
    }
  </div>
</clr-side-panel>

<app-hilfe-beschreibung-modal
  [(isModalOpen)]="isHelperModalOpen"
  [table]="'KWAART'"
  [id]="openedHelperId()"
  [readonly]="true" />
<app-baseitems-wrapper
  [(isModalOpen)]="isBaseModalOpen"
  [route]="{ tabelle: 'SMEH', title: 'Mengeneinheiten' | mrTranslate }"
  (refreshList)="updateMEH($event)" />
@if (isReadOnly()) {
  <app-mediaviewmodal
    (onClose)="wartungsMedia.set(undefined)"
    [srcs]="wartungsMedia()"
    [getMediaFromServerAll]="media.getApiFunctionMedia"
    [getBigFileFnc]="media.getApiFunctionMediaBig" />
} @else {
  <clr-modal
    #modal
    [clrModalClosable]="isNew() || !toBeSaved()"
    [clrModalOpen]="isPreviewModalOpen()"
    (clrModalOpenChange)="isPreviewModalOpen.set($event)"
    [clrModalSize]="'lg'">
    <h3 class="modal-title d-f">
      {{ mediaRow()?.artName ?? ('Wartung' | mrTranslate) }}
    </h3>
    <div class="modal-body">
      <app-preview-thumbnails
        [maxAmount]="6"
        [acceptTypes]="'image/*'"
        (deleteFile)="addDelFile($event)"
        [allowCameraVideo]="false" />
    </div>
    @if (!isNew()) {
      <div class="modal-footer">
        <button type="button" class="btn btn-outline" (click)="closePreview()">
          {{ (toBeSaved() ? 'Abbrechen' : 'Schliessen') | mrTranslate }}
        </button>
        @if (toBeSaved()) {
          <button type="button" class="btn btn-primary" (click)="saveMedia()">
            {{ 'Speichern' | mrTranslate }}
          </button>
        }
      </div>
    }
  </clr-modal>
}
